import { Box, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { forwardRef } from 'react';

import CategoryRail from '@/components/RentalRequestFlow/CategoryRail';
import useFormatMessage from '@/hooks/useFormatMessage';
import { useMobileMediaQuery } from '@/hooks/useMobileMediaQuery';

import CategorySearch from './CategorySearch/CategorySearch';

const SearchListbox = forwardRef(function SearchListbox(
  { children, onClose, ...props },
  ref
) {
  const router = useRouter();
  const formatMessage = useFormatMessage();
  const isMobile = useMobileMediaQuery();

  const renderCategories = categories => (
    <CategoryRail
      categories={categories}
      heading={formatMessage('rental_request_flow_section_categories')}
      variant={isMobile ? 'pills' : 'rail'}
      idPrefix={`${props.id}-category`}
      onSelect={category => {
        onClose();
        router.push(category.url);
      }}
      sx={{ flexShrink: 0 }}
    />
  );

  return (
    <Stack
      {...props}
      ref={ref}
      direction={{ xs: 'column', md: 'row' }}
      sx={[
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        { overflow: 'hidden' },
      ]}>
      <CategorySearch render={renderCategories} />
      <Box sx={{ flexGrow: 1, minWidth: 0, minHeight: 0, overflowY: 'auto' }}>
        <Typography
          variant="overline"
          component="h3"
          sx={{
            display: 'block',
            px: 2,
            pt: 1.5,
            pb: 0.5,
            color: 'text.secondary',
          }}>
          {formatMessage('rental_request_flow_section_products')}
        </Typography>
        <Box component="ul" role="listbox" px={0} m={0}>
          {children}
        </Box>
      </Box>
    </Stack>
  );
});

export default SearchListbox;
